<template>
  <div class="order-service-sample-files w-100">
    <fieldset>
      <legend class="d-flex">
        {{ $t('service.sampleFiles.title') }}
      </legend>

      <fieldset
        v-if="!readOnly && sampleID"
        class="mb-3">
        <legend>
          {{ $t('service.sampleFiles.addingFile') }}
        </legend>

        <label class="w-100 d-flex align-items-center">
          <file-input
            v-if="uploadInputVisible"
            :disabled="uploadInProgress"
            :onChange="setFiles"
            id="sampleFile"
            :multiple="true" />
          <div
            v-if="uploadInProgress"
            class="spinner-border spinner-border-sm ml-4"
            role="status"></div>
        </label>
      </fieldset>

      <template v-if="sampleID">
        <div
          v-for="(file, index) of sampleFiles"
          :key="'sample-file-' + file.id + '-' + index"
          class="d-block mt-2 file-item">
          <small>
            <strong>
              {{ file.file }}
            </strong>
          </small>

          <small class="d-block">
            <span
              @click.prevent="seeSampleImage(file.preview_url)"
              class="text-primary mr-2"
              style="cursor: pointer;">
              <i class="material-icons">visibility</i>
              {{ $t('service.sample.samplePhotosSeePreview') }}
            </span>

            <a
              href="#"
              @click.prevent="downloadFile(file.id, file.file_url)"
              class="mr-2">
              <div
                v-if="downloadingFile === file.id"
                class="spinner-border spinner-border-sm"
                role="status"></div>
              <i
                v-if="downloadingFile !== file.id"
                class="material-icons">cloud_download</i>
              {{ $t('service.sample.samplePhotosDownload') }}
            </a>

            <span
              class="text-danger"
              :style="'opacity:' + (deleteInProgress ? '0.25' : '1') + ';'"
              @click.prevent="deleteFile(file.id, index)">
              <div
                v-if="deleteInProgress === file.id"
                class="spinner-border spinner-border-sm"
                role="status"></div>
              <i
                v-if="!readOnly && deleteInProgress !== file.id"
                class="material-icons text-danger">delete</i>
                {{ $t('ui.delete') }}
            </span>
          </small>
        </div>

        <small
          v-if="!sampleFiles || !sampleFiles.length"
          class="d-block text-center">
          {{ $t('order.files.noServiceFilesToDisplay') }}
        </small>
      </template>
    </fieldset>
  </div>
</template>

<script>
import Vue from 'vue';
import jsonToFormData from 'json-form-data';

export default {
  name: 'order-creator-service-sample-files',
  props: [
    'sampleFiles',
    'sampleID',
    'readOnly'
  ],
  data () {
    return {
      deleteInProgress: false,
      downloadingFile: false,
      removingFile: false,
      uploadInputVisible: true,
      uploadInProgress: false,
      uploadForm: {
        files: null
      }
    };
  },
  methods: {
    uploadFile (fileIndex) {
      let uploadData = {
        order_sample_id: this.sampleID,
        file: this.uploadForm.files[fileIndex]
      };

      this.$http.request({
        method: 'POST',
        url: '/orders/services/samples/images/store',
        headers: {
          'Content-Type': undefined
        },
        transformRequest (data) {
          let dataToSend = jsonToFormData(data);
          return dataToSend;
        },
        data: uploadData
      }).then((response) => {
        if (response.data.success) {
          this.sampleFiles.push(response.data.item);
        }

        if (fileIndex === this.uploadForm.files.length - 1) {
          this.uploadInProgress = false;
          this.uploadForm.files = null;
          this.uploadInputVisible = false;

          Vue.nextTick(() => {
            this.uploadInputVisible = true;
          });
        } else {
          fileIndex++;
          this.uploadFile(fileIndex);
        }
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('service.sampleFiles.uploadError'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.uploadInProgress = false;
      });
    },
    downloadFile (fileID, fileURL) {
      if (this.downloadingFile) {
        return;
      }

      this.downloadingFile = fileID;

      this.$http.post(fileURL, null, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = response.request.getResponseHeader('content-disposition').split('filename=')[1].split(';')[0];
        link.setAttribute('download', filename.replace(/"/gmi, ''));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloadingFile = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('ui.errorOccuredDuringDownload'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.downloadingFile = false;
      });
    },
    deleteFile (fileID, index) {
      if (this.deleteInProgress) {
        return;
      }

      Vue.swal({
        title: this.$t('service.sampleFiles.removeFileTitle'),
        text: this.$t('service.sampleFiles.removeFileDesc'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('service.sampleFiles.deleteFile'),
        cancelButtonText: this.$t('ui.cancel')
      }).then((result) => {
        if (result.value) {
          this.deleteInProgress = fileID;

          this.$http.post('/orders/services/samples/images/delete/' + fileID).then(response => {
            if (response.data.success) {
              Vue.swal({
                title: this.$t('service.sampleFiles.fileDeletedTitle'),
                html: this.$t('service.sampleFiles.fileDeletedDesc'),
                type: 'success',
                confirmButtonText: this.$t('ui.ok'),
                buttonsStyling: true
              });

              this.sampleFiles.splice(index, 1);
              this.deleteInProgress = false;
            } else {
              Vue.swal({
                title: this.$t('ui.errorOccured'),
                html: this.$t('ui.tryAgain'),
                type: 'warning',
                confirmButtonText: this.$t('ui.ok'),
                buttonsStyling: true
              });
              this.deleteInProgress = false;
            }
          }).catch(error => {
            console.log(error);
            Vue.swal({
              title: this.$t('ui.errorOccured'),
              html: this.$t('ui.tryAgain'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });
            this.deleteInProgress = false;
          });
        }
      });
    },
    setFiles (event) {
      this.uploadForm.files = event.target.files;

      if (this.uploadForm.files) {
        this.uploadForm.name = '';
        this.uploadInProgress = true;
        this.uploadFile(0);
      }
    },
    seeSampleImage (url) {
      this.$bus.$emit('order-show-sample-preview', url);
    }
  }
}
</script>

<style lang="scss">
.order-service-sample-files {
  fieldset {
    border: 1px solid #ddd;
    margin-top: 10px;
    padding: 0 20px 15px 20px;

    legend {
      font-size: 16px;
      padding: 0 10px;
    }
  }

  .file-item {
    border: 1px solid #ddd;
    border-radius: 5px;
    padding: 3px 8px;

    .material-icons {
      position: relative;
      top: 3px;
    }
  }
}
</style>
